import React, { useEffect, useState } from 'react';
import { runContentBackfill } from '@/utils/run-backfill';

const BackfillRunner: React.FC = () => {
  const [isRunning, setIsRunning] = useState(false);
  const [result, setResult] = useState<any>(null);

  useEffect(() => {
    const runBackfill = async () => {
      setIsRunning(true);
      const result = await runContentBackfill();
      setResult(result);
      setIsRunning(false);
    };

    runBackfill();
  }, []);

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-4">Content Backfill Runner</h1>
      
      {isRunning && (
        <div className="mb-4">
          <div className="text-lg">Running backfill... Please wait.</div>
          <div className="animate-spin w-6 h-6 border-2 border-primary border-t-transparent rounded-full mt-2"></div>
        </div>
      )}

      {result && (
        <div className="bg-gray-100 p-4 rounded-lg">
          <h2 className="text-lg font-semibold mb-2">Results:</h2>
          <pre>{JSON.stringify(result, null, 2)}</pre>
        </div>
      )}
    </div>
  );
};

export default BackfillRunner;